export default __webpack_public_path__ + "assets/logo-heh.jpg";